/*
  ============================================================
  الويشليست — التخزين، الأزرار، العدّاد، والدرج
  ------------------------------------------------------------
  شوبيفاي مفيهاش ويشليست. الحفظ على حساب العميل محتاج تطبيق أو
  سيرفر، فالتخزين هنا على **جهاز الزائر** (localStorage).

  المعنى العملي: بيشتغل من غير تسجيل دخول وبيفضل بعد قفل المتصفح،
  بس مش بيتنقل بين الأجهزة. ده أقصى اللي ثيم لوحده بيقدر عليه.
  ============================================================
*/
(function () {
  'use strict';

  var KEY = 'gw:wishlist:v1';
  var MAX = 100;

  /* ============================================================
     كل قراءة بتعدّي على try/catch، ودي مش مبالغة:

     localStorage بيرمي استثناء في وضع التصفح الخاص في بعض
     المتصفحات، ولو المستخدم قافل الكوكيز/التخزين من الإعدادات.
     من غير الحماية دي، أول سطر في السكربت كان هيرمي والصفحة كلها
     تفضل من غير أزرار.
     ============================================================ */
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* التخزين ممتلئ أو مقفول — الواجهة تفضل شغالة للجلسة الحالية */
    }
  }

  function has(id) {
    var list = read();
    for (var i = 0; i < list.length; i += 1) {
      if (String(list[i].id) === String(id)) return true;
    }
    return false;
  }

  function remove(id) {
    var list = read().filter(function (item) {
      return String(item.id) !== String(id);
    });
    write(list);
    return list;
  }

  function add(item) {
    if (!item || !item.id) return read();
    var list = remove(item.id);
    /* الأحدث فوق — الزائر بيدوّر على آخر حاجة حفظها، مش أول واحدة */
    list.unshift(item);
    write(list);
    return list;
  }

  function toggle(item) {
    return has(item.id) ? { list: remove(item.id), saved: false } : { list: add(item), saved: true };
  }

  function emit() {
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: read() } }));
  }

  /* ---------------------------------------------------------- *
   * الأزرار
   * ---------------------------------------------------------- */

  /* ============================================================
     مستمع واحد على الدوكيومنت بدل مستمع لكل زرار.

     الكروت بتتولد بعد التحميل في أماكن كتير — الكاروسيلات،
     الفلترة، الكويك ڤيو، وإعادة رندر السكشن في المخصّص. لو ربطنا
     كل زرار وقت التحميل، أي كارت بييجي بعد كده كان هيطلع ميت.
     ============================================================ */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    event.preventDefault();
    /* الكارت كله لينك — من غير الوقفة دي الضغط بيفتح صفحة المنتج */
    event.stopPropagation();

    var item;
    try {
      item = JSON.parse(btn.getAttribute('data-wishlist-item') || '{}');
    } catch (e) {
      item = {};
    }
    if (!item.id) item.id = btn.getAttribute('data-wishlist-id');
    if (!item.id) return;

    var result = toggle(item);
    btn.classList.toggle('is-saved', result.saved);
    btn.setAttribute('aria-pressed', result.saved ? 'true' : 'false');
    btn.classList.remove('is-pulsing');
    /* إعادة تشغيل الحركة: لازم إطار كامل بينهم وإلا المتصفح
       بيشوفها نفس الحالة ومبيعيدهاش */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        btn.classList.add('is-pulsing');
      });
    });

    emit();
  });

  function syncButtons(root) {
    (root || document).querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var saved = has(btn.getAttribute('data-wishlist-id'));
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function syncCounts() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-wishlist-empty-when-zero]').forEach(function (el) {
      el.classList.toggle('wl-is-empty', n === 0);
    });
  }

  /* ---------------------------------------------------------- *
   * الدرج
   * ---------------------------------------------------------- */
  var Drawer = function (el) {
    this.el = el;
    this.list = el.querySelector('[data-wishlist-list]');
    this.empty = el.querySelector('[data-wishlist-empty]');
    this.lastFocus = null;

    el.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
  };

  Drawer.prototype.onKeydown = function (event) {
    if (event.key === 'Escape' && this.el.classList.contains('is-open')) this.close();
  };

  Drawer.prototype.onClick = function (event) {
    if (event.target.closest('[data-wishlist-close]') || event.target.hasAttribute('data-wishlist-overlay')) {
      this.close();
      return;
    }
    var del = event.target.closest('[data-wishlist-remove]');
    if (del) {
      remove(del.getAttribute('data-wishlist-remove'));
      emit();
    }
  };

  Drawer.prototype.render = function () {
    var items = read();
    if (this.empty) this.empty.hidden = items.length > 0;
    if (!this.list) return;

    if (!items.length) {
      this.list.innerHTML = '';
      return;
    }

    /* بتتبني كنص واحد وتتحط مرة واحدة — إدخال عنصر عنصر معناه
       إعادة تخطيط لكل صف. */
    this.list.innerHTML = items
      .map(function (item) {
        var img = item.img
          ? '<img class="wl-row__img" src="' + esc(item.img) + '" alt="" width="72" height="96" loading="lazy">'
          : '<span class="wl-row__img wl-row__img--none"></span>';
        return (
          '<li class="wl-row">' +
          '<a class="wl-row__media" href="' +
          esc(item.u) +
          '" tabindex="-1" aria-hidden="true">' +
          img +
          '</a>' +
          '<div class="wl-row__body">' +
          '<a class="wl-row__title" href="' +
          esc(item.u) +
          '">' +
          esc(item.t) +
          '</a>' +
          '<span class="wl-row__price">' +
          esc(item.p) +
          '</span>' +
          '</div>' +
          '<button type="button" class="wl-row__remove" data-wishlist-remove="' +
          esc(item.id) +
          '" aria-label="Remove">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
          '<path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
          '</svg>' +
          '</button>' +
          '</li>'
        );
      })
      .join('');
  };

  Drawer.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.render();
    this.el.classList.add('is-open');
    this.el.removeAttribute('hidden');
    document.body.classList.add('wl-drawer-open');
    var closeBtn = this.el.querySelector('[data-wishlist-close]');
    if (closeBtn) closeBtn.focus();
  };

  Drawer.prototype.close = function () {
    this.el.classList.remove('is-open');
    document.body.classList.remove('wl-drawer-open');
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  /* ============================================================
     الهروب من HTML.

     كل القيم دي جاية من localStorage — يعني من مكان الزائر يقدر
     يعدّل فيه بإيده من أدوات المطوّر. مينفعش تتحقن في innerHTML
     زي ما هي.
     ============================================================ */
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  /* ---------------------------------------------------------- *
   * صفحة الويشليست
   * ---------------------------------------------------------- */

  /* ============================================================
     الكروت بتتجاب من السيرفر واحد واحد.

     الصفحة مينفعش ترسم من ليكويد — المحفوظات على الجهاز والسيرفر
     مش عارف فيها حاجة. فبنطلب لكل منتج السكشن بتاعه على رابطه:

       /products/<handle>?section_id=wishlist-card

     وده بيرجّع الكارت الحقيقي كامل — بالسعر الحالي والبادچات
     والسواتشات وزرار الإضافة — مش لقطة قديمة زي اللي في الدرج.

     الطلبات على دفعات من ٦: التوازي بيخلي التحميل سريع، والحد
     بيمنع إن قايمة فيها ٥٠ منتج تفتح ٥٠ اتصال مرة واحدة.
     ============================================================ */
  var PAGE_BATCH = 6;

  function fetchCard(item) {
    var url = item.u + (item.u.indexOf('?') === -1 ? '?' : '&') + 'section_id=wishlist-card';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        /* المنتج اتمسح أو بقى مخفي — بيتشال من المحفوظات بدل ما
           يفضل صف فاضي للأبد */
        if (!res.ok) return null;
        return res.text();
      })
      .then(function (html) {
        return html ? { item: item, html: html } : null;
      })
      .catch(function () {
        /* فشل شبكة مش دليل إن المنتج اتمسح — بيتساب في مكانه */
        return { item: item, html: null };
      });
  }

  function renderPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-page-grid]');
    var empty = page.querySelector('[data-wishlist-page-empty]');
    var loading = page.querySelector('[data-wishlist-page-loading]');
    var counter = page.querySelector('[data-wishlist-page-count]');
    var items = read();

    var show = function (el, on) {
      if (el) el.hidden = !on;
    };

    if (!items.length) {
      grid.innerHTML = '';
      show(loading, false);
      show(grid, false);
      show(counter, false);
      show(empty, true);
      return;
    }

    show(empty, false);
    show(loading, true);

    var results = [];
    var index = 0;

    function next() {
      if (index >= items.length) return Promise.resolve();
      var slice = items.slice(index, index + PAGE_BATCH);
      index += PAGE_BATCH;
      return Promise.all(slice.map(fetchCard)).then(function (batch) {
        results = results.concat(batch);
        return next();
      });
    }

    next().then(function () {
      var gone = [];
      var html = '';
      results.forEach(function (entry, i) {
        if (entry === null) {
          gone.push(items[i].id);
          return;
        }
        if (entry.html === null) return;
        html += '<li class="grid__item">' + entry.html + '</li>';
      });

      if (gone.length) {
        write(
          read().filter(function (it) {
            return gone.indexOf(it.id) === -1;
          })
        );
      }

      grid.innerHTML = html;
      show(loading, false);

      /* ============================================================
         الكروت اتحقنت بعد ما الصفحة حمّلت، يعني card-product-modern.js
         عمره ما شافها — وهو اللي بيسلّح ظهور الصورة. من غير النداء ده
         الصور بتفضل `opacity: 0` والكروت تبان فاضية.

         الملف بيعرّض `window.CardModern.scan` تحديدًا للحالة دي.
         ============================================================ */
      if (window.CardModern && typeof window.CardModern.scan === 'function') {
        window.CardModern.scan(grid);
      }

      var left = read().length;
      if (!left || !html) {
        show(grid, false);
        show(counter, false);
        show(empty, true);
      } else {
        show(grid, true);
        if (counter) {
          counter.textContent = left === 1 ? '1 item' : left + ' items';
          show(counter, true);
        }
      }

      syncButtons(grid);
      syncCounts();
    });
  }

  var drawer = null;

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-wishlist-open]');
    if (!opener || !drawer) return;
    event.preventDefault();
    drawer.open();
  });

  /* ---------------------------------------------------------- *
   * التشغيل
   * ---------------------------------------------------------- */
  function init() {
    var el = document.querySelector('[data-wishlist-drawer]');
    if (el && !drawer) drawer = new Drawer(el);
    syncButtons();
    syncCounts();
    if (drawer && drawer.el.classList.contains('is-open')) drawer.render();
    renderPage();
  }

  document.addEventListener('wishlist:change', function () {
    syncButtons();
    syncCounts();
    if (drawer) drawer.render();
    /* على صفحة الويشليست نفسها، إلغاء الحفظ لازم يشيل الكارت من
       الشبكة — مش يسيبه واقف بأيقونة فاضية. */
    var page = document.querySelector('[data-wishlist-page]');
    if (page) removeCardFromPage(page);
  });

  /* بيشيل الكارت من الـ DOM على طول بدل ما يعيد جلب الصفحة كلها */
  function removeCardFromPage(page) {
    var saved = read().map(function (it) {
      return String(it.id);
    });
    page.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      if (saved.indexOf(String(btn.getAttribute('data-wishlist-id'))) !== -1) return;
      var cell = btn.closest('.grid__item');
      if (cell) cell.remove();
    });
    if (!saved.length) renderPage();
    var counter = page.querySelector('[data-wishlist-page-count]');
    if (counter && saved.length) {
      counter.textContent = saved.length === 1 ? '1 item' : saved.length + ' items';
    }
  }

  /* تبويبتين مفتوحتين لنفس المتجر: الحدث ده بيولع في التبويبة
     التانية لما دي تكتب، فالعدّاد والأزرار بيفضلوا متطابقين. */
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) {
      syncButtons();
      syncCounts();
      if (drawer) drawer.render();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* الكروت اللي بتوصل بعد كده — إعادة رندر السكشن، الفلترة، الكويك ڤيو */
  document.addEventListener('shopify:section:load', function (event) {
    init();
    syncButtons(event.target);
  });
})();
